import React from 'react'

import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { SectionPraktikKinerja } from 'app/KinerjaPenilikPegawaiPage/pages/Perencanaan/Ajukan/SectionPraktikKinerja'
import { SectionPengembanganKompetensi } from 'app/KinerjaPenilikPegawaiPage/pages/Perencanaan/Ajukan/SectionPengembanganKompetensi'
import { SectionPerilakuKerja } from 'app/KinerjaPenilikPegawaiPage/pages/Perencanaan/Ajukan/SectionPerilakuKerja'
import { usePerencanaanPenilik } from 'app/KinerjaPenilikPegawaiPage/hooks/usePerencanaan'
import { usePenilikSummary } from 'app/KinerjaPenilikPegawaiPage/hooks/useSummary'
import { SectionPelaksanaanTugas } from '../Ajukan/SectionPelaksanaanTugas'
import { humanizeDate } from 'utils/datetime'

type RangkumanProps = {}
const Rangkuman: React.FC<RangkumanProps> = ({}) => {
  // Summary
  const { perencanaan } = usePerencanaanPenilik()
  const { summary, summaryFetchStatus, isEkinSyncSuccess, ekinSyncAt } =
    usePenilikSummary()
  const showEkinSyncTimestamp = React.useMemo(
    () => isEkinSyncSuccess && Boolean(ekinSyncAt),
    [isEkinSyncSuccess, ekinSyncAt]
  )

  return (
    <div className="pb-20">
      <Header title="Rangkuman Perencanaan" className="mb-9 print:hidden" />

      <div className="max-w-5xl mx-auto space-y-10">
        {/* Praktik Kinerja */}
        <SectionPraktikKinerja data={perencanaan} />

        {/* Perilaku Kerja */}
        <SectionPerilakuKerja data={perencanaan} />

        {/* Pengembangan Kompetensi */}
        <SectionPengembanganKompetensi data={perencanaan} />

        {/* Pelaksanaan Tugas */}
        <SectionPelaksanaanTugas />

        {/* Sync E-Kinerja Timestamp */}
        {summaryFetchStatus === 'success' && showEkinSyncTimestamp && (
          <Text color="subdued" className="italic">
            Data Perencanaan berhasil dikirim ke E-Kinerja pada{' '}
            {humanizeDate(summary?.ekinSyncAt)} WIB
          </Text>
        )}
      </div>
    </div>
  )
}
export default Rangkuman
